import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { HistoryItemTypeEnum, useProductStoreBreadcrumbStore } from "@/stores/use-product-store-breadcrumb-store";

interface UseProductStoreBreadcrumbArgs {
  storeName?: string;
  productName?: string;
}

export const useProductStoreBreadcrumb = (args?: UseProductStoreBreadcrumbArgs) => {
  const { storeName, productName } = args || {};

  const pathname = usePathname();

  const { getBreadcrumbItems, isUserInGalleryPage, handleNewHistoryEntry, getItemFromType, setItemNameFromType } =
    useProductStoreBreadcrumbStore();

  useEffect(() => {
    handleNewHistoryEntry(pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (storeName && !getItemFromType(HistoryItemTypeEnum.STORE)?.name) {
      setItemNameFromType(HistoryItemTypeEnum.STORE, storeName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeName]);

  useEffect(() => {
    if (productName && !getItemFromType(HistoryItemTypeEnum.PRODUCT)?.name) {
      setItemNameFromType(HistoryItemTypeEnum.PRODUCT, productName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productName]);

  return {
    breadcrumbItems: getBreadcrumbItems(),
    isGalleryPage: isUserInGalleryPage(),
  };
};
